import { Button } from '@progress/kendo-react-buttons';
import { Dialog } from '@progress/kendo-react-dialogs';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import { Label } from '@progress/kendo-react-labels';
import classNames from 'classnames';
import React from 'react';
import Configuration from '../../dispatcher/config/Configuration';
import Component from '../../dispatcher/modules/component/Component';
import withFormControl from '../hoc/form/withFormControl';
import { config } from './LoginPage.config';
import { Position } from '../../dispatcher/Types';
import LocalCache from '../../utility/LocalCache';
// @ts-ignore
import Properties from 'properties';
import Mask from '../../dispatcher/modules/mask/Mask';
import { LOGIN_PAGE_PROPS, LOGIN_PAGE_STATE } from './Types';

class LoginPage extends Component<LOGIN_PAGE_PROPS, LOGIN_PAGE_STATE> {
  passwordRef: any;
  state:LOGIN_PAGE_STATE = {
    forceSsoLogin: false,
    badCredentials: null
  };

  moduleDidMount = () => {
    LocalCache.remove(['impersonate'], 'sessionStorage'); // If user has been redirected to login on switch (for some reason)
    // init auth here so that login can user redirect to signin
    this.dispatch('runAuthService');
    this.passwordRef?._input.setAttribute('type', 'password');
    let urlSearchParams = new URLSearchParams(window.location.search);
    const { APP_SKIP_LOGIN } = Properties;
    if (urlSearchParams.has('force-sso-login') || APP_SKIP_LOGIN) {
      this.setState({
        forceSsoLogin: true
      });
    }
  };

  updateBadCredentialsMessage = (badCredentials: boolean) => {
    this.setState({
      badCredentials: badCredentials ? this.translate('badCredentials') : null
    });
  };

  /**
   * Submit user info to login as a local user
   */
  onSubmit = (e: any) => {
    e.preventDefault();
    const isValid = this.props.form.runFullValidation();
    if (isValid) {
      const data = this.props.form.getData();
      this.dispatch('loginRequest', '', data);
    }
  };

  renderLoginPage = () => {
    const { getAllConfigField, getFields, handleChange } = this.props.form;
    const { username, password } = getFields();
    const { username: usernameAllConfig, password: passwordAllConfig } = getAllConfigField();
    const { APP_LOGIN_TYPE } = Configuration.get();
    const loginSSO = APP_LOGIN_TYPE === 'TYPE_SSO';
    const loginLOCAL = APP_LOGIN_TYPE === 'TYPE_LOCAL';
    const loginCOMBINED = APP_LOGIN_TYPE === 'TYPE_COMBINED';
    const loginDialogCls = classNames('tp-login-dialog-wrapper', {
      'tp-login-sso': APP_LOGIN_TYPE === 'TYPE_SSO',
      'tp-login-local': APP_LOGIN_TYPE === 'TYPE_LOCAL',
      'tp-login-combined': APP_LOGIN_TYPE === 'TYPE_COMBINED'
    });
    return (
      <div className={'tp-window-wrapper'}>
        <Dialog
          id={'loginWindow'}
          title={this.translate('loginTitle')}
          className={`${loginDialogCls} tp-login-dialog`}
        >
          <div className='tp-login-logo'>
            <span
              aria-hidden="true"
              className={'tp-logo-text'}
            >
              {this.translate('logoText')}
            </span>
          </div>
          {loginSSO || loginCOMBINED ? <div
            className={'k-form-field-wrap tp-login-sso-btn-field-wrap'}
          >
            <div className={'k-form-field'}>
              <Button
                className='tp-login-sso-btn'
                themeColor={'primary'}
                onClick={() => this.dispatch('signInRequest', Position.end)}
              >
                <div className={'tp-tpt-logo-wrap'}>
                  <span className={'tp-tpt-logo'} />
                </div>
                {loginSSO ? <span
                  className={'tp-login-sso-btn-text'}
                >
                  {this.translate('login_sso')}
                </span> : <span
                  className={'tp-login-sso-btn-text'}
                >
                  {this.translate('login_sso_local')}
                </span>
                }
              </Button>
            </div>
          </div> : null
          }
          <form className={'k-form'} onSubmit={this.onSubmit}>
            {loginCOMBINED || loginLOCAL ? <>
              <div className={'k-form-field-wrap tp-login-username-field'}>
                <div className='k-form-field'>
                  <Label
                    editorId={'username'}
                  >{this.translate('username')}</Label>
                  <MaskedTextBox
                    name='username'
                    id={'username'}
                    size={'large'}
                    onChange={handleChange}
                    {...username}
                  />
                  <div
                    className={'tp-validation-error-message'}
                    id={username.ariaDescribedBy}
                  >
                    {this.translateErrorMessage(usernameAllConfig)}
                  </div>
                </div>
              </div>
              <div className={'k-form-field-wrap tp-login-password-field'}>
                <div className='k-form-field'>
                  <Label
                    editorId={'password'}
                  >{this.translate('password')}</Label>
                  <MaskedTextBox
                    size={'large'}
                    name='password'
                    // TODO type is missing(but working), check after migration to newer kendo version
                    // @ts-ignore
                    type={'password'}
                    id={'password'}
                    ref={(el: any) => this.passwordRef = el}
                    onChange={handleChange}
                    {...password}
                  />
                  <div
                    className={'tp-validation-error-message'}
                    id={password.ariaDescribedBy}
                  >
                    {this.translateErrorMessage(passwordAllConfig)}
                  </div>
                </div>
              </div>
              {/* <div className={'k-form-field-wrap tp-login-checkbox-field'}>*/}
              {/*  <div className="k-form-field k-display-inline-flex k-justify-content-end">*/}
              {/*    <div className={'k-form-checkbox-wrap'}>*/}
              {/*      <input*/}
              {/*        className={'k-checkbox'}*/}
              {/*        type="checkbox"*/}
              {/*        value="lsRememberMe"*/}
              {/*        id="rememberMe"*/}
              {/*      />*/}
              {/*    </div>*/}
              {/*    <label>*/}
              {/*      {this.translate('remember_me')}*/}
              {/*    </label>*/}
              {/*  </div>*/}
              {/* </div>*/}
              <div className={'k-form-field-wrap tp-login-btn-field'}>
                <div className={'k-form-field'}>
                  {this.getBadCredentials()}
                  <Button className={'tp-login-button'} themeColor={'primary'}>
                    {this.translate('login')}
                  </Button>
                </div>
              </div>
              <div
                className={'k-form-field-wrap tp-login-forgot-pass-field'}
              >
                <div
                  className={'k-form-field k-display-flex k-align-items-end'}
                >
                  <a
                    href='https://www.transperfect.com/user'
                    className="tp-link tp-text-semibold"
                  >
                    {this.translate('forgot_password')}
                  </a>
                </div>
              </div>
            </> : null
            }
          </form>
        </Dialog>
      </div>
    );
  }

  renderBody() {
    const { forceSsoLogin } = this.state;
    let render;
    if (forceSsoLogin) {
      render = (
        <Mask
          message={this.translate('logging')}
        />
      );
    } else {
      render = this.renderLoginPage();
    }
    return render;
  }

  private getBadCredentials() {
    const { badCredentials } = this.state;
    return badCredentials ? <div
      data-cy={'wrong_credentials'}
      className={'tp-validation-error-message'}
    >{badCredentials}</div> : null;
  }
}

export default withFormControl<LOGIN_PAGE_PROPS>(config)(LoginPage);
export {
  LoginPage as LoginPageComponent
};
